import Image from "next/image";
import style from "./StyleSelector.module.scss";
import SelectorWrapper from "../SelectorWrapper/SelectorWrapper";

function StyleSelector({ dictionary, selectedStyle = {}, isShown = false, closeSelector = () => {}, selectStyle = () => {}, stylesList = [] }) {
	const transformName = (nameStr) => {
		if (nameStr.split("").includes("-")) {
			return nameStr
				.split("-")
				.map((item) => {
					return item.toLowerCase();
				})
				.join("_");
		}
		return nameStr
			.split(" ")
			.map((str) => {
				return str.toLowerCase();
			})
			.join("_");
	};

	return (
		<SelectorWrapper isShown={isShown} closeWrapper={(e) => closeSelector(e)}>
			<div className={style.container} id="style-selector">
				<div className={style["container-scroll"]}>
					<button
						onClick={() => {
							selectStyle({
								name: "No style",
								image_url: "/remove_back/magic_bg/no_style.png",
								isNoStyle: true,
								id: 0,
							});
							closeSelector();
						}}
						className={`${style.btn} ${0 === selectedStyle.id ? style.active : ""} ${style["selector-block-btn"]}`}
						key={0}
					>
						<div className={style["image-box"]}>
							<Image
								className={style.image}
								src={"/remove_back/magic_bg/no_style.png"}
								alt={`AI generated image in no style`}
								style={{ objectFit: "contain", maxWidth: "100%", height: "auto" }}
								width={151}
								height={151}
								loading={"lazy"}
							/>
						</div>
						<p className={style["btn-title"]}>{dictionary["No style"] || "No style"}</p>
					</button>
					{stylesList.map((item, idx) => {
						if (idx === 0) {
							return (
								<button
									id={item.id === selectedStyle.id ? "active-style" : "style-btn"}
									onClick={() => {
										selectStyle(item);
										closeSelector();
									}}
									className={`${style.btn} ${item.id === selectedStyle.id ? style.active : ""} ${style["selector-block-btn"]}`}
									key={item.id}
								>
									<div className={style["image-box"]}>
										<Image
											className={style.image}
											src={item.image_url}
											alt={`AI generated image in ${item.name.toLowerCase()} style`}
											style={{ objectFit: "contain", maxWidth: "100%", height: "auto" }}
											width={151}
											height={151}
											unoptimized={true}
											loading={"lazy"}
										/>
									</div>
									<p className={style["btn-title"]}>{dictionary[transformName(item.name)] || dictionary[item.name] || item.name}</p>
								</button>
							);
						}
						return (
							<button
								onClick={() => {
									selectStyle(item);
									closeSelector();
								}}
								className={`${style.btn} ${item.id === selectedStyle.id ? style.active : ""} ${style["selector-block-btn"]}`}
								key={item.id}
							>
								<div className={style["image-box"]}>
									<Image
										className={style.image}
										src={item.image_url}
										alt={`AI generated image in ${item.name.toLowerCase()} style`}
										style={{ objectFit: "contain", maxWidth: "100%", height: "auto" }}
										width={151}
										height={151}
										unoptimized={true}
										loading={"lazy"}
									/>
								</div>
								<p className={style["btn-title"]}>{dictionary[transformName(item.name)] || dictionary[item.name] || item.name}</p>
							</button>
						);
					})}
				</div>
			</div>
		</SelectorWrapper>
	);
}

export default StyleSelector;
